<template lang="pug">
  .-answers-analytics__users-row
    .-answers-analytics__users-col
      p.table__text.-overflow-.-answers-analytics__users-title
      | {{ user.name }} {{user.lastname}}
    .-answers-analytics__users-col
      p.table__text.-overflow-.-answers-analytics__text
        | {{ user.courseName }} &nbsp;
      p.table__text.-overflow-.-answers-analytics__users-text(v-if="getTariff")
        | {{getTariff.name}}
    .-answers-analytics__users-col
      p.table__text.-overflow-.-answers-analytics__users-title__main(
        @click="click"
      )
        | {{ user.lessonName }}
    .-answers-analytics__users-col
      p.table__text.-overflow-.-answers-analytics__text
        | {{ checkInDate }}
</template>
<script>
import moment from 'moment';

export default {
  props: ['user', 'tariffs'],
  computed: {
    getTariff() {
      return this.tariffs.find(el => el.id === this.user.tariffId);
    },
    checkInDate() {
      return moment(this.user.dateToCheck).format('DD.MM.YYYY');
    }
  },
  methods: {
    click() {
      this.$router.push({
        path: '/answers/validating/feed',
        query: {
          userId: this.user.id,
          name: this.user.email,
          taskBlock: {
            lessonId: this.user.lessonId,
            id: this.user.taskBlockId,
            variety: this.user.taskBlockVariety
          },
          courseId: this.user.courseId
        }
      });
    }
  }
};
</script>
